<div class="main-page-area">
    <div class="main-page-content">
        <eff-step-header
            [controlGuid]="effectivenessModel.controlGuid"
            [title]="'effWorkflowSteps.controlTesting' | t"
            (onSaveChanges)="save(true)"
            (onShowInstructions)="toggleInstructions()"
            [ngClass]="{ 'is-step-rejected': pageState.isRejected }"
            [showNonOccurrenceWarningArea]="isNonOccurrenceTestPlan"
        >
        </eff-step-header>

        @if (pageState.isRejected) {
            <author-message-box
                [author]="pageState.rejectedBy"
                [authorLabelKey]="pageState.rejectedByRoleKey"
                [message]="pageState.rejectionMessage"
            >
            </author-message-box>
        }

        <eff-checkbox
            class="expand-collapse-all"
            [label]="'effGrid.openAll' | t"
            (modelChange)="expandCollapseAll($event, tableConfig?.DisableRowFunc)"
        ></eff-checkbox>

        <div class="main-grid d-flex flex-column">
            @for (viewSample of viewSamples; track viewSample) {
                <div>
                    <div class="grid-header justify-content-between">
                        <div class="bold-text">{{ 'effGrid.sampleLabel' | t: { name: viewSample.sample.name } }}</div>
                        <eff-inline-text-editor
                            [label]="'effGrid.addSampleRemark' | t"
                            [disabled]="!stepPermissions.isEditSampleRemarkAllowed"
                            [(model)]="viewSample.sample.remarks"
                            (complete)="saveRemarksChange(viewSample.sample)"
                        ></eff-inline-text-editor>
                        @if (viewSample.sample.taskData) {
                            <div
                                class="task-link-label"
                                (click)="openTask(viewSample.sample.taskData)"
                            >
                                <i class="fas fa-regular fa-link-horizontal"></i>
                                <label>
                                    {{ viewSample.sample.taskData.actionDate | dateFormat }}</label
                                >
                            </div>
                        }
                    </div>
                    <eff-table
                        [dataSource]="viewSample.gridDataSource"
                        [columns]="displayedColumns"
                        [tableConfig]="tableConfig"
                        [expandedRowTemplate]="expandedTemplate"
                    >
                        <ng-template #expandedTemplate let-item="item">
                            <div class="grid-expanded-row">
                                <div class="table-row">
                                    <div class="table-cell documents">
                                        <div class="d-flex flex-column gap-3">
                                            @if (item.noEvidence) {
                                                <div class="d-flex flex-column gap-2">
                                                    <eff-checkbox
                                                        [disabled]="true"
                                                        [checked]="true"
                                                        [label]="'effGrid.noEvidence' | t"
                                                        data-uiid="eff-testing-no-evidence-checkbox"
                                                    ></eff-checkbox>
                                                    <div class="no-evidence-inner">
                                                        <eff-textarea
                                                            class="grid-textarea-style"
                                                            [(model)]="item.noEvidenceReason"
                                                            [disabled]="true"
                                                            [bordered]="false"
                                                            [popupTitle]="'effGrid.commentNoEvidence' | t"
                                                            uiid="no-evidence"
                                                            [label]="'effGrid.addComment' | t"
                                                        ></eff-textarea>
                                                    </div>
                                                </div>
                                            }
                                            <documents-list
                                                class="documets-list-small-droparea"
                                                [class.hidden]="
                                                    item.isSample &&
                                                    isSampleDisabled(item) &&
                                                    totalDocumentCount(item) === 0
                                                "
                                                [documents]="item.documents"
                                                [canAdd]="stepPermissions.evidenceSaveAllowed"
                                                [canEdit]="stepPermissions.evidenceSaveAllowed"
                                                [canDelete]="stepPermissions.evidenceSaveAllowed"
                                                [taskDocuments]="item.taskData?.documents"
                                                [isSample]="item.isSample"
                                                (documentsChange)="documentsChange($event, item)"
                                            ></documents-list>
                                        </div>
                                    </div>
                                    <div class="table-cell tester-comment">
                                        <div class="d-flex flex-column gap-score-text">
                                            @if (showReviewColumn && pageState.isRejected) {
                                                <div>
                                                    <ng-container
                                                        *ngTemplateOutlet="
                                                            testerScoreTemplate;
                                                            context: { item: item }
                                                        "
                                                    ></ng-container>
                                                </div>
                                            }
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    testerCommentTemplate;
                                                    context: { item: item }
                                                "
                                            ></ng-container>
                                        </div>
                                    </div>
                                    <div class="table-cell tester-score">
                                        <div class="reviewer-score-inner">
                                            @if (showReviewColumn && pageState.isRejected) {
                                                <div class="reviewer-comment">
                                                    @if (stepPermissions.evidenceSaveAllowed) {
                                                        <eff-textarea
                                                            class="grid-textarea-style"
                                                            [(model)]="item.commentReviewer"
                                                            [bordered]="false"
                                                            [disabled]="true"
                                                            uiid="reviewer-comment"
                                                            [popupTitle]="'effGrid.commentReviewer' | t"
                                                        ></eff-textarea>
                                                    }
                                                </div>
                                            } @else {
                                                <div>
                                                    <ng-container
                                                        *ngTemplateOutlet="
                                                            testerScoreTemplate;
                                                            context: { item: item }
                                                        "
                                                    ></ng-container>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                @if (item.isLateTask) {
                                    <div class="sample-warning completed-later">
                                        <div class="sample-later-warning-text">
                                        {{ 'effTestingTest.controlExecutionLateWarning' | t }}
                                        </div>
                                        <div class="sample-later-warning-text padding-top-8">
                                            {{
                                                'effGrid.controlExecutionCompletedAt'
                                                | t: { date: (item.taskData.completedAt | dateTimeFormat) }
                                            }}
                                        </div>
                                    </div>
                                }
                                @if (item.isOpenTask) {
                                    <div class="sample-warning not-completed">
                                        <div class="sample-not-completed-warning-text">
                                            {{ 'effTestingTest.controlExecutionNotFinishedWarning' | t }}
                                        </div>
                                    </div>
                                }
                            </div>
                        </ng-template>
                        <ng-template column-name="name" let-item="item">
                            <div class="d-flex flex-row gap-3 align-items-center">
                                <div
                                    [ngClass]="{ 'sample-name-cell': item.isSample }"
                                    class="regular-text"
                                >
                                    {{ (item.isSample ? 'effTestingTest.sample' : 'effTestingTest.step') | t }} {{ item.name }}
                                </div>
                                @if (totalDocumentCount(item) > 0) {
                                    <div class="d-flex flex-row align-items-center gap-1">
                                        <eff-icon
                                            class="remark-icon"
                                            icon="attachment_outlined"
                                        ></eff-icon>
                                        <div>({{ totalDocumentCount(item) }})</div>
                                    </div>
                                }
                                @if (item.noEvidence && item.noEvidenceReason) {
                                    <div>
                                        <eff-icon
                                            class="remark-icon"
                                            icon="comment_outlined"
                                        ></eff-icon>
                                    </div>
                                }
                            </div>
                        </ng-template>
                        <ng-template column-name="testerComment" let-item="item">
                            @if (!item.IsExpanded) {
                                @if (showReviewColumn && pageState.isRejected) {
                                    <div class="score-comment d-flex flex-row">
                                        <ng-container
                                            *ngTemplateOutlet="
                                                testerScoreView;
                                                context: { item: item }
                                            "
                                        ></ng-container>
                                        @if (item.commentTester) {
                                            <div>
                                                <eff-icon
                                                    class="remark-icon"
                                                    icon="comment_outlined"
                                                ></eff-icon>
                                            </div>
                                        }
                                    </div>
                                } @else {
                                    <div>
                                        @if (item.commentTester) {
                                            <eff-icon
                                                class="remark-icon"
                                                icon="comment_outlined"
                                            ></eff-icon>
                                        } @else {
                                            <div class="add-comment-label">{{ 'effTestingTest.addComment' | t }}</div>
                                        }
                                    </div>
                                }
                            }
                        </ng-template>
                        <ng-template column-name="score" let-item="item">
                            @if (!item.IsExpanded) {
                                <div>
                                    <ng-container
                                        *ngTemplateOutlet="testerScoreView; context: { item: item }"
                                    ></ng-container>
                                </div>
                            }
                        </ng-template>
                        <ng-template column-name="commentReviewer" let-item="item">
                            @if (!item.IsExpanded && item.commentReviewer) {
                                <div>
                                    <eff-icon
                                        class="remark-icon"
                                        icon="comment_outlined"
                                    ></eff-icon>
                                </div>
                            }
                        </ng-template>
                    </eff-table>
                </div>
            }
        </div>

        <ng-template #testerScoreTemplate let-item="item">
            <div>
                @if (stepPermissions.evidenceSaveAllowed) {
                    <div>
                        @if (item.isSample) {
                            <eff-colored-selector
                                [disabled]="isSampleDisabled(item)"
                                [options]="sampleScores"
                                [model]="item.sampleScore"
                                [triggerOpen]="item.triggerOpenScore"
                                (modelChange)="onScoreChanged($event, item)"
                            >
                            </eff-colored-selector>
                        } @else {
                            <eff-colored-selector
                                [options]="stepScores"
                                [(model)]="item.stepScore"
                                [triggerOpen]="item.triggerOpenScore"
                                (modelChange)="onScoreChanged($event, item)"
                            >
                            </eff-colored-selector>
                        }
                    </div>
                } @else {
                    <div>
                        <ng-container
                            *ngTemplateOutlet="testerScoreView; context: { item: item }"
                        ></ng-container>
                    </div>
                }
            </div>
        </ng-template>

        <ng-template #testerScoreView let-item="item">
            <div
                class="d-flex flex-row align-items-center status-cell"
                [class.disabled]="isSampleDisabled(item)"
            >
                <div class="status-bullet" [ngClass]="getScoreColor(item)"></div>
                @if (stepPermissions.evidenceSaveAllowed) {
                    <div>
                        @if (item.isSample) {
                            <div>
                                {{ item.sampleScore == 0 ? ('effTestingTest.addScoreCell' | t) : item.scoreName }}
                            </div>
                        } @else {
                            <div>
                                {{ item.stepScore == 0 ? ('effTestingTest.addScoreCell' | t) : item.scoreName }}
                            </div>
                        }
                    </div>
                } @else {
                    <div>
                        {{ item.scoreName }}
                    </div>
                }
            </div>
        </ng-template>

        <ng-template #testerCommentTemplate let-item="item">
            <div class="tester-comment-inner">
                @if (stepPermissions.evidenceSaveAllowed) {
                    <eff-textarea
                        [disabled]="
                            (item.isSample && isSampleDisabled(item)) ||
                            !stepPermissions.evidenceSaveAllowed
                        "
                        class="grid-textarea-style"
                        [(model)]="item.commentTester"
                        [label]="'effGrid.addComment' | t"
                        uiid="tester-comment"
                        [popupTitle]="'effGrid.commentTester' | t"
                        (modelChange)="onChangesDebounce()"
                    ></eff-textarea>
                }
            </div>
        </ng-template>

        <div class="bottom-buttons-wrapper">
            @if (isNonOccurrenceTestPlan) {
                @if (stepPermissions.isEditAllowed) {
                    <eff-button
                        [text]="'effTestingTest.rejectNonOccurrenceButton' | t"
                        size="large-size"
                        class="bottom-button missing-evidence-btn"
                        (click)="onRejectNonOccurrenceClick()"
                    ></eff-button>
                    <eff-button
                        [text]="'effTestingTest.acceptNonOccurrenceButton' | t"
                        size="large-size"
                        class="bottom-button final-conclusion-btn"
                        (click)="onAcceptNonOccurrenceClick()"
                    ></eff-button>
                }
            } @else if (!isNonOccurrenceTestPlan && stepPermissions.evidenceSaveAllowed) {
                <eff-button
                    [text]="'effTestingTest.rejectMissingEvidenceButton' | t"
                    size="large-size"
                    class="bottom-button missing-evidence-btn"
                    data-uiid="eff-testing-test-reject-missing-evidence-button"
                    (click)="onMissingEvidenceClick()"
                ></eff-button>
                <eff-button
                    [text]="'effTestingTest.finalConclusionButton' | t"
                    size="large-size"
                    class="bottom-button final-conclusion-btn"
                    (click)="onFinalConclusionClick()"
                ></eff-button>
            }
        </div>
    </div>

    <div class="side-page-area">
        <eff-test-instructions-info-box
            [panelOpenState]="true"
            [samples]="samples"
            [effectivenessModel]="effectivenessModel"
        >
        </eff-test-instructions-info-box>
        <eff-evidence-instructions-info-box
            [samples]="samples"
            [instructions]="effectivenessModel.evidenceUploadInstructions"
        >
        </eff-evidence-instructions-info-box>
        <eff-source-document-info-box
            [effectivenessModel]="effectivenessModel"
            [stepPermissions]="stepPermissions"
        ></eff-source-document-info-box>
        <eff-control-info-box [controlGuid]="effectivenessModel.controlGuid"></eff-control-info-box>
    </div>
</div>

<cerrix-slide-over #cerrixSlideOver>
    <ng-template #title>
        <div class="paragraph">
            <div class="header">{{ 'effTestingTest.howToTestTitle' | t }}</div>
        </div>
    </ng-template>
    <ng-template #content>
        <div class="paragraph">
            <div class="header">{{ 'effTestingTest.howToTestSection1Header' | t }}</div>
            <div class="content">
                <ol>
                    <li>
                        {{ 'effTestingTest.helpDownloadEvidence' | t }}
                        <ol type="i">
                            <li>{{ 'effTestingTest.helpNavigateToDocument' | t }}</li>
                            <li>{{ 'effTestingTest.helpClickDownload' | t }}</li>
                        </ol>
                    </li>
                    <li>
                        {{ 'effTestingTest.helpEvaluateTestSteps' | t }}
                        <ol type="i">
                            <li>{{ 'effTestingTest.helpAnalyseByStepDescription' | t }}</li>
                            <li>{{ 'effTestingTest.helpSelectScore' | t }}</li>
                            <li>{{ 'effTestingTest.helpCommentRecommended' | t }}</li>
                            <li>{{ 'effTestingTest.helpBeConcise' | t }}</li>
                        </ol>
                    </li>
                    <li>
                        {{ 'effTestingTest.helpSaveEvaluation' | t }}
                        <ol type="i">
                            <li>{{ 'effTestingTest.helpClickSaveChanges' | t }}</li>
                        </ol>
                    </li>
                </ol>
            </div>
        </div>
        <div class="paragraph">
            <div class="header">{{ 'effTestingTest.howToTestSection2Header' | t }}</div>
            <div class="content">
                <ol>
                    <li>
                        {{ 'effTestingTest.helpDownloadEvidence' | t }}
                        <ol type="i">
                            <li>{{ 'effTestingTest.helpNavigateToDocument' | t }}</li>
                            <li>{{ 'effTestingTest.helpClickDownload' | t }}</li>
                        </ol>
                    </li>
                    <li>
                        {{ 'effTestingTest.helpEvaluateSample' | t }}
                        <ol type="i">
                            <li>{{ 'effTestingTest.helpAnalyseByTestInstruction' | t }}</li>
                            <li>{{ 'effTestingTest.helpSelectScore' | t }}</li>
                            <li>{{ 'effTestingTest.helpCommentRequired' | t }}</li>
                            <li>{{ 'effTestingTest.helpBeConcise' | t }}</li>
                        </ol>
                    </li>
                    <li>
                        {{ 'effTestingTest.helpSaveEvaluation' | t }}
                        <ol type="i">
                            <li>{{ 'effTestingTest.helpClickSaveChanges' | t }}</li>
                        </ol>
                    </li>
                </ol>
            </div>
        </div>
        <div class="paragraph">
            <div class="content">
                {{ 'effTestingTest.helpTwoButtonsIntro' | t }}
            </div>
        </div>
        <div class="paragraph">
            <div class="header">{{ 'effTestingTest.howToTestSection3Header' | t }}</div>
            <div class="content">
                <ol>
                    <li>
                        {{ 'effTestingTest.helpIdentifyMissingEvidence' | t }}
                        <ol type="i">
                            <li>{{ 'effTestingTest.helpIdentifyIfMissing' | t }}</li>
                        </ol>
                    </li>
                    <li>
                        {{ 'effTestingTest.helpNotifyUploader' | t }}
                        <ol type="i">
                            <li>{{ 'effTestingTest.helpClickMissingEvidence' | t }}</li>
                            <li>{{ 'effTestingTest.helpPopupSpecifyMissing' | t }}</li>
                            <li>{{ 'effTestingTest.helpConfirmNotification' | t }}</li>
                        </ol>
                    </li>
                </ol>
            </div>
        </div>
        <div class="paragraph">
            <div class="header">{{ 'effTestingTest.howToTestSection4Header' | t }}</div>
            <div class="content">
                <ol>
                    <li>
                        {{ 'effTestingTest.helpGiveFinalScore' | t }}
                        <ol type="i">
                            <li>{{ 'effTestingTest.helpClickGiveFinalScore' | t }}</li>
                            <li>{{ 'effTestingTest.helpSelectScoreByNorm' | t }}</li>
                            <li>{{ 'effTestingTest.helpArticulateRationale' | t }}</li>
                        </ol>
                    </li>
                    <li>
                        {{ 'effTestingTest.helpCompleteTestStage' | t }}
                        <ol type="i">
                            <li>{{ 'effTestingTest.helpClickConfirmComplete' | t }}</li>
                        </ol>
                    </li>
                </ol>
            </div>
        </div>
    </ng-template>
</cerrix-slide-over>
